<template>
  <div class="smallCardsComponent">
    <div class="playingCard" v-for="data in cardData" :key="data.cardString" :style="data.style">
      <Card :cardString="data.cardString" :height="height" />
    </div>
  </div>
</template>

<script>
import Card from "./Card";

export default {
  name: "SmallCards",
  components: { Card },
  props: {
    cards: { type: Array, default: () => [] },
  },
  computed: {
    height() {
      return 40;
    },
    cardData() {
      return this.cards.map((card, i) => {
        const right = (this.cards.length - 1 - i) * 10;
        return {
          cardString: card,
          style: { right: `${right}px` },
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.smallCardsComponent {
  position: relative;
  height: 0;
}
.playingCard {
  position: absolute;
  top: -20px;
}
</style>
